import * as z from "zod/v4";

export const upsertTrackingPageGlobalSettings = {
  name: "upsertTrackingPageGlobalSettings" as const,
  input: z.object({ loadingBackgroundColor: z.string().optional() }),
  output: z.object({ loadingBackgroundColor: z.string().optional() }),
};
